/**
 * @Relay no-runtime
 */
/**
 * @graphql cc
 */
import graphql from 'graphql-tag';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from 'react-apollo';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { isUnauthorizedError } from '@confluence/error-boundary/entry-points/isUnauthorizedError.ts';
import { isNotFoundError } from '@confluence/error-boundary/entry-points/isNotFoundError.ts';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';

import type { usePremiumGatePremiumGateQuery as usePremiumGatePremiumGateQuery$data } from './__types__/usePremiumGatePremiumGateQuery.ts';

export const usePremiumGate = () => {
	const { edition } = useSessionData();
	const canSkipEntitlementCheck = edition === ConfluenceEdition.PREMIUM;

	const { data, error } = useQuery<usePremiumGatePremiumGateQuery$data>(
		graphql`
			query usePremiumGatePremiumGateQuery {
				entitlements {
					premiumExtensions {
						isEntitled
					}
				}
			}
		`,
		{
			skip: canSkipEntitlementCheck,
		},
	);

	if (error) {
		if (!(isUnauthorizedError(error) || isNotFoundError(error))) {
			getMonitoringClient().submitError(error, {
				attribution: Attribution.PERFORMANCE_INSIGHTS,
			});
		}
		markErrorAsHandled(error);
	}

	return !canSkipEntitlementCheck && !data?.entitlements.premiumExtensions.isEntitled;
};
